module.exports = __webpack_public_path__ + "static/img/eTower_normal.0f5ab17a.png";